import { render, staticRenderFns } from "./TableToggleItem.vue?vue&type=template&id=d2afca54&"
import script from "./TableToggleItem.vue?vue&type=script&lang=js&"
export * from "./TableToggleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports